module.exports = __webpack_public_path__ + "img/ic_bonus.f9cc14fa.png";